import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { SaveIcon } from 'lucide-react';
export function DatiAnagraficiTab() {
  const [formData, setFormData] = useState({
    ragioneSociale: 'Acme Srl',
    partitaIVA: '12345678901',
    codiceFiscale: '12345678901',
    indirizzo: 'Via Roma, 123',
    cap: '20100',
    citta: 'Milano',
    provincia: 'MI',
    codiceSdi: 'T04ZHR3',
    pec: 'acme@pec.it',
    emailAmministrazione: 'amministrazione@acme.it'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Logica per salvare i dati
    alert('Dati salvati con successo');
  };
  return <Card data-id="element-1185">
      <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1186">
        Dati Anagrafici Società
      </h3>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1187">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-1188">
          <div data-id="element-1189">
            <label htmlFor="ragioneSociale" className="block text-sm font-medium text-gray-700" data-id="element-1190">
              Ragione Sociale
            </label>
            <input type="text" name="ragioneSociale" id="ragioneSociale" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.ragioneSociale} onChange={handleChange} required data-id="element-1191" />
          </div>
          <div data-id="element-1192">
            <label htmlFor="partitaIVA" className="block text-sm font-medium text-gray-700" data-id="element-1193">
              Partita IVA
            </label>
            <input type="text" name="partitaIVA" id="partitaIVA" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.partitaIVA} onChange={handleChange} required data-id="element-1194" />
          </div>
          <div data-id="element-1195">
            <label htmlFor="codiceFiscale" className="block text-sm font-medium text-gray-700" data-id="element-1196">
              Codice Fiscale
            </label>
            <input type="text" name="codiceFiscale" id="codiceFiscale" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.codiceFiscale} onChange={handleChange} required data-id="element-1197" />
          </div>
          <div data-id="element-1198">
            <label htmlFor="indirizzo" className="block text-sm font-medium text-gray-700" data-id="element-1199">
              Indirizzo
            </label>
            <input type="text" name="indirizzo" id="indirizzo" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.indirizzo} onChange={handleChange} required data-id="element-1200" />
          </div>
          <div data-id="element-1201">
            <label htmlFor="cap" className="block text-sm font-medium text-gray-700" data-id="element-1202">
              CAP
            </label>
            <input type="text" name="cap" id="cap" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.cap} onChange={handleChange} required data-id="element-1203" />
          </div>
          <div data-id="element-1204">
            <label htmlFor="citta" className="block text-sm font-medium text-gray-700" data-id="element-1205">
              Città
            </label>
            <input type="text" name="citta" id="citta" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.citta} onChange={handleChange} required data-id="element-1206" />
          </div>
          <div data-id="element-1207">
            <label htmlFor="provincia" className="block text-sm font-medium text-gray-700" data-id="element-1208">
              Provincia
            </label>
            <input type="text" name="provincia" id="provincia" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.provincia} onChange={handleChange} required maxLength={2} data-id="element-1209" />
          </div>
          <div data-id="element-1210">
            <label htmlFor="codiceSdi" className="block text-sm font-medium text-gray-700" data-id="element-1211">
              Codice SDI
            </label>
            <input type="text" name="codiceSdi" id="codiceSdi" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.codiceSdi} onChange={handleChange} required data-id="element-1212" />
          </div>
          <div data-id="element-1213">
            <label htmlFor="pec" className="block text-sm font-medium text-gray-700" data-id="element-1214">
              PEC
            </label>
            <input type="email" name="pec" id="pec" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.pec} onChange={handleChange} required data-id="element-1215" />
          </div>
          <div data-id="element-1216">
            <label htmlFor="emailAmministrazione" className="block text-sm font-medium text-gray-700" data-id="element-1217">
              Email Amministrazione
            </label>
            <input type="email" name="emailAmministrazione" id="emailAmministrazione" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={formData.emailAmministrazione} onChange={handleChange} required data-id="element-1218" />
          </div>
        </div>
        <div className="flex justify-end" data-id="element-1219">
          <Button type="submit" icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-1221" />} data-id="element-1220">
            Salva Dati
          </Button>
        </div>
      </form>
    </Card>;
}